import axios from "axios";
import { ApiKey, liveURL } from "../../const/constants";

const MAIN_URL = `${liveURL}/websiteArticles`;
const GET_ARTICLE = `${MAIN_URL}/getArticles`;
const CATEGORY_COUNT = `${MAIN_URL}/getArticleCountsByCategory`;
const GET_ARTICLE_BY_ID = `${MAIN_URL}/getArticlesById`;
const GET_ARTICLE_BY_CATEGORY = `${MAIN_URL}/getArticlesByCategory`;
const GET_STARRED_ARTICLE = `${MAIN_URL}/getSratedArticles`;

//get userdetail
export async function getArticle() {
  try {
    const response = await axios.get(GET_ARTICLE, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    return console.log(error);
  }
}
export async function getCategoriesCount() {
  try {
    const response = await axios.get(CATEGORY_COUNT, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    return console.log(error);
  }
}

export async function getArticleById(id) {
  try {
    const response = await axios.get(`${GET_ARTICLE_BY_ID}/${id}`, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    return console.log(error);
  }
}

export async function getStarredArticles() {
  try {
    const response = await axios.get(`${GET_STARRED_ARTICLE}`, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    return console.log(error);
  }
}

export async function getArticleByCategory(category) {
  try {
    const response = await axios.get(
      `${GET_ARTICLE_BY_CATEGORY}?category=${category}`,
      {
        headers: {
          apikey: ApiKey,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching articles:", error);
    return { Result: false, Msg: error.message };
  }
}
